import { useContext, useEffect, useState } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";

export const HorizonTable = () => {
  const [lstore] = useContext(LocalStoreContext);
  const [store] = useContext(StoreContext);
  const { controlPopupMenu, defaultTicker } = store;
  const { horizon } = lstore;
  const [vscore, setVscore] = useState();

  useEffect(() => {
    if (
      horizon.rawdata.length > 0 &&
      "horizon" in controlPopupMenu.selected &&
      "spiderTicker" in controlPopupMenu.selected
    ) {
      const fdata = horizon.rawdata
        .filter((row) => {
          return row.Column_2 === controlPopupMenu.selected["spiderTicker"];
        })
        .map((item) => {
          return { horizon: item.Column_68, vscore: item.Column_54 };
        })
        .sort((a, b) =>
          +a.horizon > +b.horizon ? 1 : +a.horizon < +b.horizon ? -1 : 0
        );

      const s = fdata
        .map((item) => +item.vscore)
        .reduce((total, val) => total + val);

      setVscore({ data: fdata, total: s });
    }
  }, [
    horizon,
    controlPopupMenu.label,
    controlPopupMenu.selected,
    defaultTicker,
  ]);

  const containerStyle = { margin: 10 };

  const footStyle = {
    fontSize: 16,
    color: "#4472C4",
    fontWeight: 600,
    textAlign: "right",
  };
  const headStyle = {
    fontSize: 16,
    fontWeight: 600,
    textAlign: "right",
  };

  const bodyStyle = { fontSize: 14, textAlign: "right" };
  const gapStyle = {
    width: 20,
  };

  return vscore && vscore.data ? (
    <div style={containerStyle}>
      <table>
        <thead style={headStyle}>
          <tr>
            <td>Horizon</td>
            <td style={gapStyle}></td>
            <td>Score</td>
          </tr>
        </thead>
        <tbody style={bodyStyle}>
          {vscore.data.map((item, i) => {
            return (
              <tr key={i}>
                <td>{item.horizon}</td>
                <td style={gapStyle}></td>
                <td>{item.vscore}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot style={footStyle}>
          <tr>
            <td>Sum</td>
            <td style={gapStyle}></td>
            <td>{vscore.total}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  ) : null;
};
